import CommunitiesSection from './CommunitiesSection';

export default CommunitiesSection;
